import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
    return (
        <div className="min-h-screen bg-paper flex items-center justify-center" data-testid="not-found-page">
            <div className="container-editorial text-center pt-40 pb-40">
                <div className="overlabel text-earth mb-6">Error 404</div>
                <h1 className="font-serif text-6xl md:text-8xl leading-none tracking-tight mb-8">
                    Off the trail.
                </h1>
                <p className="text-ink/70 max-w-md mx-auto mb-12 leading-relaxed">
                    The page you were looking for is not here. Return home and explore the breeds.
                </p>
                <Link
                    to="/"
                    className="inline-flex items-center gap-3 bg-forest text-paper px-8 py-4 rounded-full text-sm tracking-wide hover:bg-gold hover:text-ink transition-colors duration-500"
                    data-testid="notfound-home"
                >
                    Back to home <ArrowRight size={16} strokeWidth={1.5} />
                </Link>
            </div>
        </div>
    );
}
